import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  merchantCode: undefined, // optional - Merchant Code
  clientCode: undefined, // optional - Client Code
  secureKey: undefined, // optional - SecureKey
};

// validation form
model.validForm = {
  merchantCode: [ValidService.required, ValidService.checkNumber], // optional - Merchant Code
  clientCode: [ValidService.required, ValidService.checkNumber], // optional - Client Code
  secureKey: [ValidService.required], // optional - SecureKey
};

export default model;
